(function() {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var content = document.querySelector('[data-cart-content]');
  var totalEl = document.querySelector('[data-cart-total]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var cart = null;

  function formatMoney(amount) {
    return (amount / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateCount() {
    var count = cart && cart.item_count ? cart.item_count : 0;
    countEls.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderError(form, message) {
    var existing = form.querySelector('.cart-error');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.className = 'cart-error';
    div.setAttribute('role', 'alert');
    div.textContent = message;
    form.appendChild(div);
  }

  function removeFormError(form) {
    var existing = form.querySelector('.cart-error');
    if (existing) existing.remove();
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderItem(item) {
    var price = formatMoney(item.final_price);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var image = item.image
      ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title || '') + '" width="64" height="64" loading="lazy">'
      : '<div class="cart-drawer__image-placeholder"></div>';

    return '<li class="cart-drawer__item" data-item-key="' + item.key + '">' +
      '<div class="cart-drawer__item-image">' + image + '</div>' +
      '<div class="cart-drawer__item-details">' +
        '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title || '') + '</p>' +
        (variant ? '<p class="cart-drawer__item-variant">' + escapeHtml(variant) + '</p>' : '') +
        '<p class="cart-drawer__item-price">' + price + '</p>' +
      '</div>' +
      '<div class="cart-drawer__item-actions">' +
        '<button type="button" class="cart-drawer__qty-btn" data-cart-decrease data-item-key="' + item.key + '" aria-label="Reducir cantidad">−</button>' +
        '<span class="cart-drawer__qty" data-cart-quantity data-item-key="' + item.key + '">' + item.quantity + '</span>' +
        '<button type="button" class="cart-drawer__qty-btn" data-cart-increase data-item-key="' + item.key + '" aria-label="Aumentar cantidad">+</button>' +
        '<button type="button" class="cart-drawer__remove" data-cart-remove data-item-key="' + item.key + '" aria-label="Eliminar artículo">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M3 6h18"></path>' +
            '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>' +
            '<path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
            '<line x1="10" y1="11" x2="10" y2="17"></line>' +
            '<line x1="14" y1="11" x2="14" y2="17"></line>' +
          '</svg>' +
        '</button>' +
      '</div>' +
    '</li>';
  }

  function renderCart() {
    if (!cart) return;
    if (cart.item_count === 0) {
      content.innerHTML = '<p class="cart-drawer__empty">El carrito está vacío.</p>';
    } else {
      var html = '<ul class="cart-drawer__items" data-cart-items>' + cart.items.map(renderItem).join('') + '</ul>';
      content.innerHTML = html;
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    updateCount();
  }

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        cart = data;
        renderCart();
      })
      .catch(function(err) {
        console.error('CartDrawer: error loading cart', err);
      });
  }

  function showDrawer() {
    if (!drawer) return;
    if (!drawer.open) {
      drawer.showModal();
      document.body.classList.add('cart-drawer-open');
    }
  }

  function openDrawer() {
    loadCart().then(showDrawer);
  }

  function closeDrawer() {
    if (!drawer) return;
    if (drawer.open) drawer.close();
    document.body.classList.remove('cart-drawer-open');
  }

  function handleAddResponse(res) {
    if (!res.ok) {
      return res.json().then(function(data) {
        throw new Error((data && data.description) || 'Error al añadir al carrito');
      });
    }
    return res.json();
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ id: variantId, quantity: quantity })
    }).then(handleAddResponse);
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ id: key, quantity: quantity })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Error al actualizar el carrito');
      return res.json();
    })
    .then(function(data) {
      cart = data;
      renderCart();
    })
    .catch(function(err) {
      console.error('CartDrawer: error changing item', err);
    });
  }

  function handleDrawerClick(e) {
    if (e.target === drawer) {
      closeDrawer();
      return;
    }

    var btn = e.target.closest('[data-cart-increase], [data-cart-decrease], [data-cart-remove]');
    if (!btn) return;

    var key = btn.getAttribute('data-item-key');
    if (!key || !cart) return;

    var item = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) {
        item = cart.items[i];
        break;
      }
    }
    if (!item) return;

    var qty;
    if (btn.hasAttribute('data-cart-remove')) {
      qty = 0;
    } else if (btn.hasAttribute('data-cart-increase')) {
      qty = item.quantity + 1;
    } else {
      qty = Math.max(1, item.quantity - 1);
    }

    changeItem(key, qty);
  }

  function onProductFormSubmit(e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    removeFormError(form);

    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variantId = idInput ? idInput.value : '';
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    if (!variantId) {
      renderError(form, 'Selecciona una variante para continuar.');
      return;
    }
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    addToCart(variantId, quantity)
      .then(function() { return loadCart(); })
      .then(function() { showDrawer(); })
      .catch(function(err) {
        renderError(form, err.message || 'No se pudo añadir el producto al carrito.');
      });
  }

  function onCartTriggerClick(e) {
    var openLink = e.target.closest('[data-cart-open]');
    if (!openLink) return;
    e.preventDefault();
    openDrawer();
  }

  if (drawer) {
    drawer.addEventListener('click', handleDrawerClick);
    drawer.addEventListener('close', function() {
      document.body.classList.remove('cart-drawer-open');
    });
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  }

  document.addEventListener('click', onCartTriggerClick);
  document.addEventListener('submit', onProductFormSubmit);

  loadCart();
})();
